import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from '@angular/material/icon';
import { MAT_SELECT_CONFIG, MatSelectModule } from "@angular/material/select";
import { MatRadioModule } from "@angular/material/radio";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { AppRoutingModule } from './app-routing.module';
import { AppIconModule } from './app-icons.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LockedoutComponent } from './components/lockedout/lockedout.component';
import { CardstatusComponent } from './components/card-status/cardstatus.component';
import { TimeoutComponent } from './components/timeout/timeout.component';
import { SendemailComponent } from './components/send-email/sendemail.component';
import { AuthInterceptor } from './services/interceptor/auth.interceptor';
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { DatePipe } from "@angular/common";
import { ExceededTriesComponent } from './components/exceeded-tries/exceeded-tries.component';
import { AlertUrgentComponent } from './components/common/alert-urgent/alert-urgent.component';
import { AlertInformationComponent } from './components/common/alert-information/alert-information.component';
import {
  CardStatusExceededTriesComponent
} from './components/card-status/card-status-exceeded-tries/card-status-exceeded-tries.component';
import { CardStatusSuccessComponent } from './components/card-status/card-status-success/card-status-success.component';
import { AlertSuccessComponent } from './components/common/alert-success/alert-success.component';
import { ErrorComponent } from "./components/error/error.component";
import { SendEmailSuccessComponent } from './components/send-email/send-email-success/send-email-success.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OverlayModule } from "@angular/cdk/overlay";
import { CdkMenuModule } from "@angular/cdk/menu";
import { FooterComponent } from './components/footer/footer.component';
import { LoginCallbackComponent } from './components/login-callback/login-callback.component';
import { StoreModule } from "@ngrx/store";
import { authOauthReducer } from "./stores/auth/auth.reducer";
import { cardNumbersReducer, saveEmailReducer } from "./stores/user-input/user-input.reducer";
import { NgIdleModule } from "@ng-idle/core";
import { MAT_CARD_CONFIG } from "@angular/material/card";
import { MAT_RIPPLE_GLOBAL_OPTIONS } from "@angular/material/core";


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LockedoutComponent,
    CardstatusComponent,
    TimeoutComponent,
    SendemailComponent,
    ErrorComponent,
    ExceededTriesComponent,
    AlertUrgentComponent,
    AlertInformationComponent,
    CardStatusExceededTriesComponent,
    CardStatusSuccessComponent,
    AlertSuccessComponent,
    SendEmailSuccessComponent,
    FooterComponent,
    LoginCallbackComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AppIconModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatIconModule,
    MatSelectModule,
    MatRadioModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDividerModule,
    FormsModule,
    MatProgressSpinnerModule,
    OverlayModule,
    CdkMenuModule,
    NgIdleModule.forRoot(),
    StoreModule.forRoot({
      authOauthReducer: authOauthReducer,
      saveEmailReducer: saveEmailReducer,
      cardNumbersReducer: cardNumbersReducer
    })],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    // AuthGuard,
    DatePipe,
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {
        appearance: 'outline',
        subscriptSizing: 'dynamic',
        color: 'primary'
      }
    },
    {
      provide: MAT_CARD_CONFIG, useValue: {
        appearance: 'outline',
      }
    },
    {
      provide: MAT_SELECT_CONFIG, useValue: {
        disableOptionCentering: true,
        overlayPanelClass: 'icbc-dropdown'
      }
    },
    {
      provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: {
        disabled: true,
      }
    }
  ],

})
export class AppModule {

}
